module.exports = __webpack_public_path__ + "assets/2_2_3_IFOK_WIM_INTEROPERABILITY_AI_Platformfor_svg_je.36b93c27.svg";